import { ICapture, IPending } from '../shared/types'
import { CompletedCaptureRow, PendingCaptureRow } from './capture-row'

type PendingProps = {
    captures: IPending[]
}
export const PendingCaptureList = ({ captures }: PendingProps) => {
    return (
        <>
            {captures.map((p: IPending, i: number) => {
                return <PendingCaptureRow key={i} capture={p} />
            })}
        </>
    )
}

type CompletedProps = {
    captures: ICapture[]
    showUsername: boolean
    onCaptureDeleted: (id: string) => void
}
export const CompletedCaptureList = ({ captures, showUsername, onCaptureDeleted }: CompletedProps) => {
    return (
        <>
            {captures.map((c: ICapture, i: number) => {
                return (
                    <CompletedCaptureRow
                        key={i}
                        showUsername={showUsername}
                        capture={c}
                        onCaptureDeleted={onCaptureDeleted}
                    />
                )
            })}
        </>
    )
}
